import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    index: PropTypes.number,
    active: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

const defaultProps = {
    index: 0,
    active: false
};

export default function NumberButton(props) {
    const pageIndex = props.index;
    const oneIndexedPage = pageIndex + 1;
    if (props.active) {
        return (
            <li key={`page-${oneIndexedPage}-button`}>
                <button
                    aria-label={`Current Page, Page ${oneIndexedPage}`}
                    className="rec-active-page"
                    data-page={oneIndexedPage}>
                    {oneIndexedPage}
                </button>
            </li>
        );
    }

    return (
        <li key={`page-${oneIndexedPage}-button`}>
            <button
                aria-label={`Page ${oneIndexedPage}`}
                data-page={oneIndexedPage}
                onClick={() => props.onClick(pageIndex)}>
                {oneIndexedPage}
            </button>
        </li>
    );
}

NumberButton.propTypes = propTypes;
NumberButton.defaultProps = defaultProps;
